import * as React from 'react';
import { NoNavigationPageWrapper } from '../../designSystem/layouts/pageWrappers/NoNavigationPageWrapper';
import { PublicPageProvider } from '../_contexts/PublicPageContext';
import { PasswordResetConfirmationPanel } from './_components/PasswordResetConfirmationPanel';

export default function ConfirmPasswordResetPage (): JSX.Element
{
    return (
        <PublicPageProvider>
            <NoNavigationPageWrapper>
                <PasswordResetConfirmationPanel />
            </NoNavigationPageWrapper>
        </PublicPageProvider>
    );
}